document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.referenceSwiper').forEach((el) => {
        new Swiper(el, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            freeMode: true,
            mousewheel: {
                forceToAxis: true
            },
        });
    });
});
